import Description from "Components/Global/Typography/Description";
import Title from "Components/Global/Typography/Title";

import * as S from "./styles.js";

const TypographyHead = ({ title, description, dark }) => {
  return (
    <S.Wrapper>
      <Title dark={dark}>{title}</Title>
      <Description dark={dark}>{description}</Description>
    </S.Wrapper>
  );
};

export default TypographyHead;
